export default "__VITE_ASSET__CZSYtTXF__"